const Item = ({ itemValue, keyValue }) => {
  return (
    //13.8
    <div
      className=" ml-8 font-sans font-medium text-txtColor text-[15px]"
      key={keyValue}
    >
      <input type="checkbox" class="accent-btnColor" className="mr-3" />
      {itemValue}
    </div>
  );
};

export default Item;
